import { Component } from '@angular/core';

@Component({
    selector: 'app-support-group-respiratory',
    templateUrl: './support-group-respiratory.component.html',
    styleUrls: ['./support-group-respiratory.component.scss'],
})
export class SupportGroupRespiratoryComponent {
    constructor() {}
}
